import {
  CHALLENGE_DAILY_PROFIT_LOCK_MESSAGE,
  RISK_PROFILE_LOCK_MESSAGE,
  CLOSE_ONLY_MESSAGE,
  CHALLENGE_ENDED_MESSAGE,
} from '../utils/tradingLockMessage.ts';

/** Map known English banner constants to translated strings. Server/dynamic text passes through. */
export function localizeTradingBannerMessage(message, t) {
  if (!message) return null;
  const known = {
    [CHALLENGE_DAILY_PROFIT_LOCK_MESSAGE]: t('tradingLock.dailyProfitLock'),
    [RISK_PROFILE_LOCK_MESSAGE]: t('tradingLock.riskLock'),
    [CLOSE_ONLY_MESSAGE]: t('tradingLock.closeOnly'),
    [CHALLENGE_ENDED_MESSAGE]: t('tradingLock.challengeEnded'),
  };
  return known[message] || message;
}
